import React from 'react';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';
import { lazy, type LazyComponent } from '@atlassian/react-loosely-lazy';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';

export const AgentPresenceHeartbeatLazyLoader: LazyComponent<() => JSX.Element | null> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazy(() =>
		import(
			/* webpackChunkName: "async-agent-presence-heartbeat" */ './AgentPresenceHeartbeat.tsx'
		).then((module) => module.AgentPresenceHeartbeat),
	);

export const AgentPresenceHeartbeatLazy = (): JSX.Element => (
	<ContextualAnalyticsData sourceName="agentPresenceHeartbeat">
		<JSErrorBoundary
			id="agentPresenceHeartbeat"
			packageName="jiraServicedeskAgentPresenceHeartbeat"
			teamName="jsd-shield"
			fallback="unmount"
		>
			<AgentPresenceHeartbeatLazyLoader />
		</JSErrorBoundary>
	</ContextualAnalyticsData>
);
